export const ImageLink = (name) => {
    if (name) {
        const imageUrl = process.env.REACT_APP_FILE_BASE_URL
        return `${imageUrl}${name}`;
    }
};
